import { render, staticRenderFns } from "./CallCenterUsers.vue?vue&type=template&id=553c1805&"
import script from "./CallCenterUsers.vue?vue&type=script&lang=ts&"
export * from "./CallCenterUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports